<template>
  <v-container class="pa-4">
    <v-row no-gutters>
      <v-col cols="12">
        <v-btn
          fab
          x-small
          :color="site.color"
          @click="redirectTo()"
          dark
          class="mb-4"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="d-flex justify-center">
        <div style="max-height: 240px">
          <img
            :src="dataItem.image_url"
            style="
              max-width: 100%;
              max-height: 240px;
              width: auto;
              height: auto;
              border-radius: 10px;
              object-fit: contain;
              display: block;
              margin: 0 auto;
            "
            @error="onImageError($event, dataItem, 'image_url')"
          />
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-3" style="margin-bottom: 120px">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="text-subtitle-1 text--primary mx-0 text-center mb-0">
              {{ dataItem.name }}
            </p>
          </v-col>
        </v-row>

        <v-tabs
          v-model="tab"
          background-color="transparent"
          :color="site.color"
          fixed-tabs
          flat
          class="mt-2"
        >
          <v-tab
            href="#tab-1"
            style="background: #ffffff; border-radius: 8px 0px 0px 0px"
            >{{ $t("detail") }}
          </v-tab>
          <v-tab
            href="#tab-2"
            style="background: #ffffff; border-radius: 0px 8px 0px 0px"
          >
            {{ $t("activity") }}
          </v-tab>
          <v-tabs-items v-model="tab" class="mt-2" style="border-radius: 8px">
            <v-tab-item :value="'tab-1'">
              <v-row
                v-if="
                  ['success', 'waiting', 'failed'].includes(
                    dataItem.mission_status
                  )
                "
                no-gutters
              >
                <v-col cols="12">
                  <v-card
                    ref="cardDetailMission"
                    elevation="0"
                    outlined
                    @click="handleClickDetailMission"
                  >
                    <v-card class="d-flex pr-2">
                      <v-card-text>{{ $t("detailMission") }}</v-card-text>
                      <v-icon>{{
                        showMissionDetail
                          ? "mdi-chevron-down"
                          : "mdi-chevron-right"
                      }}</v-icon>
                    </v-card>

                    <v-row no-gutters class="px-3" v-if="showMissionDetail">
                      <v-col
                        cols="12"
                        class="text-start pa-0 d-flex justify-start"
                      >
                        <v-chip
                          class="mt-2 mb-4 text-center white--text"
                          :color="site.color"
                          small
                        >
                          {{ category(dataItem.category) }}
                        </v-chip>
                      </v-col>

                      <v-col
                        cols="12"
                        class="text-start pa-0 d-flex justify-start"
                      >
                        <v-row no-gutters>
                          <v-col
                            cols="12"
                            class="text-start pa-0 d-flex justify-start align-center mb-4"
                          >
                            <div class="ml-4" style="width: 48px">
                              <v-icon :color="site.color"
                                >mdi-calendar-clock</v-icon
                              >
                            </div>
                            <div>
                              <div style="font-size: 10px">
                                {{ $t("activityExpireDate") }}
                              </div>
                              <div style="font-size: 14px; color: #00000099">
                                {{ dataItem.end_date | formatDate }}
                              </div>
                            </div>
                          </v-col>
                          <v-col
                            cols="12"
                            class="text-start pa-0 d-flex justify-start align-center mb-4"
                            v-if="dataItem.use_reward == false"
                          >
                            <div class="ml-4" style="width: 48px">
                              <PointSymbol
                                v-if="
                                  Array.isArray(dataItem.point) &&
                                  dataItem.point.length > 0
                                "
                                :type="dataItem.point[0].point_type_type"
                                :symbol="dataItem.point[0].point_type_symbol"
                                :color="dataItem.point[0].point_type_color"
                                :is_display="true"
                                :outlined_box="false"
                                :size="30"
                              />
                            </div>
                            <div>
                              <div style="font-size: 10px">
                                {{ $t("collectCoin") }}
                              </div>
                              <div style="font-size: 14px; color: #00000099">
                                {{ showPoint(dataItem) }}
                              </div>
                            </div>
                          </v-col>
                          <v-col
                            cols="12"
                            class="text-start pa-0 d-flex justify-start align-center mb-4"
                            v-else
                          >
                            <div class="ml-4" style="width: 48px">
                              <v-icon :color="site.color">mdi-gift</v-icon>
                            </div>
                            <div>
                              <div style="font-size: 10px">
                                {{ $t("missionReward") }}
                              </div>
                              <div style="font-size: 14px; color: #00000099">
                                {{ getRewardName(dataItem) }}
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="12">
                            <v-card elevation="0">
                              <p
                                class="text-subtitle-2 mb-0 ml-4 font-weight-bold"
                              >
                                {{ $t("detail") }}
                              </p>
                              <div
                                class="ml-4 ql-editor"
                                style="height: fit-content"
                                v-html="formatHtmlDetail(dataItem.detail)"
                              ></div>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else no-gutters>
                <v-col cols="12" class="text-start pa-0 d-flex justify-start">
                  <v-chip
                    class="mb-4 mt-2 ml-2 text-center white--text"
                    :color="site.color"
                    small
                  >
                    {{ category(dataItem.category) }}
                  </v-chip>
                  <v-spacer></v-spacer>
                  <v-chip
                    v-if="dataItem.is_top_ranking"
                    class="mt-2 mb-4 mr-2 text-center"
                    :color="site.color"
                    small
                    outlined
                    @click="goToTopRanking"
                  >
                    {{ $t("textTopRanking") }}
                    <v-icon small> mdi-chevron-right </v-icon>
                  </v-chip>
                </v-col>

                <v-col cols="12" class="text-start pa-0 d-flex justify-start">
                  <v-chip
                    class="mb-4 ml-2"
                    color="black"
                    dark
                    small
                    v-if="dataItem.anonymous == true"
                  >
                    <v-icon small>mdi-account-cowboy-hat-outline</v-icon>
                    {{ $t("textIncognito") }}
                  </v-chip>
                </v-col>

                <v-col cols="12" class="text-start pa-0 d-flex justify-start">
                  <v-row no-gutters>
                    <v-col
                      cols="12"
                      class="text-start pa-0 d-flex justify-start align-center mb-4"
                    >
                      <div class="ml-4" style="width: 48px">
                        <v-icon :color="site.color">mdi-calendar-clock</v-icon>
                      </div>
                      <div>
                        <div style="font-size: 10px">
                          {{ $t("activityExpireDate") }}
                        </div>
                        <div style="font-size: 14px; color: #00000099">
                          {{ dataItem.end_date | formatDate }}
                        </div>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      class="text-start pa-0 d-flex justify-start align-center mb-4"
                      v-if="dataItem.use_reward == false"
                    >
                      <div class="ml-4" style="width: 48px">
                        <PointSymbol
                          v-if="
                            Array.isArray(dataItem.point) &&
                            dataItem.point.length > 0
                          "
                          :type="dataItem.point[0].point_type_type"
                          :symbol="dataItem.point[0].point_type_symbol"
                          :color="dataItem.point[0].point_type_color"
                          :is_display="true"
                          :outlined_box="false"
                          :size="30"
                        />
                      </div>
                      <div>
                        <div style="font-size: 10px">
                          {{ $t("collectCoin") }}
                        </div>
                        <div style="font-size: 14px; color: #00000099">
                          {{ showPoint(dataItem) }}
                        </div>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      class="text-start pa-0 d-flex justify-start align-center mb-4"
                      v-else
                    >
                      <div class="ml-4" style="width: 48px">
                        <v-icon :color="site.color">mdi-gift</v-icon>
                      </div>
                      <div>
                        <div style="font-size: 10px">
                          {{ $t("missionReward") }}
                        </div>
                        <div style="font-size: 14px; color: #00000099">
                          {{ getRewardName(dataItem) }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-card elevation="0">
                        <p class="text-subtitle-2 mb-0 ml-4 font-weight-bold">
                          {{ $t("detail") }}
                        </p>
                        <div
                          class="ml-4 ql-editor"
                          style="height: fit-content"
                          v-html="formatHtmlDetail(dataItem.detail)"
                        ></div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row
                v-if="
                  dataItem.type !== 'import' &&
                  dataItem.type != 'kahoot' &&
                  dataItem.type != 'lucky draw' &&
                  $route.params.status !== 'all' &&
                  $route.params.status !== '0' &&
                  (dataItem.mission_status === 'success' ||
                    dataItem.mission_status === 'waiting' ||
                    dataItem.mission_status === 'failed')
                "
                no-gutters
                class="mt-4 px-4"
              >
                <v-col
                  cols="12"
                  class="text-start pa-0 d-flex justify-start"
                  v-if="user"
                >
                  <p class="text-subtitle-1 font-weight-bold mb-0">
                    {{ $t("doActivityBy") }}
                  </p>
                </v-col>
                <v-col
                  cols="12"
                  class="text-start pa-0 d-flex justify-start"
                  v-if="user"
                >
                  <v-list two-line class="pa-0">
                    <v-list-item class="pa-0">
                      <v-list-item-avatar size="40" style="background: black">
                        <v-img
                          :src="
                            user.image_path ? user.image_path : defaultImage
                          "
                        ></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          class="ql-editor pa-0"
                          style="
                            line-height: normal !important;
                            height: fit-content;
                          "
                          v-html="user?.name"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          class="ql-editor pa-0"
                          style="
                            line-height: normal !important;
                            height: fit-content;
                          "
                          v-html="user?.phone"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>

                <v-col cols="12" class="text-start pa-0 d-flex justify-start">
                  <p class="text-subtitle-1 font-weight-bold mb-0">
                    {{ $t("doneDetailMission") }}
                  </p>
                </v-col>

                <v-col cols="12" class="text-start pa-0 d-flex justify-start">
                  <v-row no-gutters style="max-width: 100%">
                    <!-- exam || survey -->
                    <v-col
                      v-if="
                        survey &&
                        (dataItem.type === 'exam' || dataItem.type === 'survey')
                      "
                      cols="12"
                    >
                      <Survey
                        v-if="survey"
                        :survey="survey"
                        class="mt-4"
                        style="
                          border-radius: 8px;
                          background-color: transparent;
                        "
                      />
                    </v-col>
                    <v-col
                      v-else-if="
                        dataItem.type === 'exam' ||
                        (dataItem.type === 'survey' && answer == null)
                      "
                      cols="12"
                    >
                      <div justify="center">
                        <v-col class="d-flex justify-center mt-10">
                          <v-img
                            class="white--text mx-auto mt-10"
                            :src="require('@/assets/images/close.png')"
                            max-width="150px"
                          >
                          </v-img>
                        </v-col>
                        <p class="mt-5 my-15 text-center">
                          {{ $t("errActivityDataNotFound") }}
                        </p>
                      </div>
                    </v-col>

                    <!-- upload -->
                    <v-col
                      v-else-if="dataItem.type === 'upload'"
                      justify="center"
                      cols="12"
                    >
                      <v-row no-gutters justify="center">
                        <v-col class="mt-2">
                          <p class="font-weight-bold">
                            •
                            {{
                              schema_survey
                                ? schema_survey.pages[0].elements[0].title
                                : $t("instructionUploadImageVideo", {
                                    size: 10,
                                  })
                            }}
                          </p>

                          <div v-if="isImage(dataItem.image_upload)">
                            <v-img :src="dataItem.image_upload"></v-img>
                          </div>
                          <div v-else-if="isVideo(dataItem.image_upload)">
                            <v-col cols="12">
                              <vue-plyr ref="plyr">
                                <video
                                  controls
                                  crossorigin
                                  playsinline
                                  data-plyr-config='{ "ratio": "4:3" }'
                                >
                                  <source
                                    :src="dataItem.image_upload"
                                    size="720"
                                    type="video/mp4"
                                  />
                                </video>
                              </vue-plyr>
                            </v-col>
                          </div>
                          <div v-else-if="isPDF(dataItem.image_upload)">
                            <v-icon color="red" class="mx-1"
                              >mdi-file-pdf-box</v-icon
                            >
                            <a :href="dataItem.image_upload">file</a>
                          </div>
                          <div v-else-if="isSpreadsheet(dataItem.image_upload)">
                            <v-icon color="green" class="mx-1"
                              >mdi-file-excel</v-icon
                            >
                            <a :href="dataItem.image_upload">file</a>
                          </div>

                          <div v-else>
                            <p>{{ $t("textUnsupportedFileType") }}</p>
                          </div>
                          <p class="font-weight-bold mt-4">
                            • {{ $t("textAdditionalDescription") }}
                          </p>

                          <p class="font-weight-medium">
                            {{ formattedText(dataItem.description) }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-col>

                    <!-- check-in -->
                    <v-col
                      v-else-if="dataItem.type === 'check-in' && check_in"
                      cols="12"
                    >
                      <v-row no-gutters>
                        <v-col class="mt-2">
                          <p class="font-weight-bold mt-4">
                            • {{ $t("textLocationOrBranchName") }}
                          </p>
                          <p class="font-weight-medium">
                            {{ check_in.title }}
                          </p>
                          <p class="font-weight-bold mt-4">
                            • {{ $t("textCheckInTime") }} :
                          </p>
                          <p class="font-weight-medium">
                            {{ check_in.check_in }}
                          </p>
                          <p
                            class="font-weight-bold mt-4"
                            v-if="check_in.check_out"
                          >
                            • {{ $t("textCheckOutTime") }} :
                          </p>
                          <p class="font-weight-medium">
                            {{ check_in.check_out }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-col>

                    <!-- multi-upload -->
                    <v-col
                      v-else-if="dataItem.type === 'multi-upload'"
                      cols="12"
                    >
                      <v-row no-gutters justify="center">
                        <v-col cols="12" class="mt-2">
                          <p class="font-weight-bold">
                            {{ formatTitleSurvey("upload", dataItem) }}
                          </p>
                          <div v-if="isImage(dataItem.image_upload)">
                            <v-img :src="dataItem.image_upload"></v-img>
                          </div>
                          <div v-else-if="isVideo(dataItem.image_upload)">
                            <v-col cols="12">
                              <vue-plyr ref="plyr">
                                <video
                                  controls
                                  crossorigin
                                  playsinline
                                  data-plyr-config='{ "ratio": "4:3" }'
                                >
                                  <source
                                    :src="dataItem.image_upload"
                                    size="720"
                                    type="video/mp4"
                                  />
                                </video>
                              </vue-plyr>
                            </v-col>
                          </div>
                          <div v-else>
                            <p>{{ $t("textUnsupportedFileType") }}</p>
                          </div>
                          <p class="font-weight-bold mt-4">
                            {{ formatTitleSurvey("amount", dataItem) }}
                          </p>
                          <p class="font-weight-medium">
                            {{
                              dataItem.description
                                ? dataItem.description.toString()
                                : "-"
                            }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-col>

                    <!-- survey-summary -->
                    <v-col
                      v-else-if="dataItem.type === 'survey-summary'"
                      cols="12"
                    >
                      <v-row no-gutters justify="center">
                        <v-col class="mt-2">
                          <div v-if="isImage(dataItem.image_upload)">
                            <v-img :src="dataItem.image_upload"></v-img>
                          </div>
                          <div v-else-if="isVideo(dataItem.image_upload)">
                            <v-col cols="12">
                              <vue-plyr ref="plyr">
                                <video
                                  controls
                                  crossorigin
                                  playsinline
                                  data-plyr-config='{ "ratio": "4:3" }'
                                >
                                  <source
                                    :src="dataItem.image_upload"
                                    size="720"
                                    type="video/mp4"
                                  />
                                </video>
                              </vue-plyr>
                            </v-col>
                          </div>
                          <div v-else-if="dataItem.image_upload">
                            <p>{{ $t("textUnsupportedFileType") }}</p>
                          </div>
                          <v-textarea
                            class="mt-3"
                            label=""
                            outlined
                            readonly
                            no-resize
                            auto-grow
                            rows="1"
                            v-model="descriptionTextarea"
                          >
                          </v-textarea>
                        </v-col>
                      </v-row>
                    </v-col>

                    <!-- quest-tracking -->
                    <v-col
                      v-else-if="dataItem.type === 'quest-tracking'"
                      cols="12"
                    >
                      <questTrackingData
                        :questTrackingData="questTrackingData"
                        :site="site"
                        :conditionSpecial="conditionSpecial"
                      ></questTrackingData>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row
                no-gutters
                class="px-4"
                v-if="dataItem.mission_status == 'failed'"
              >
                <v-col cols="12" class="text-start pa-0 d-flex justify-start">
                  <p class="text-subtitle-1 font-weight-bold mb-0 mt-2">
                    {{ $t("note") }}
                  </p>
                </v-col>
                <v-col cols="12" class="text-start pa-0 d-flex justify-start">
                  <v-textarea
                    label=""
                    outlined
                    readonly
                    no-resize
                    auto-grow
                    rows="1"
                    v-model="noteFailTextarea"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :value="'tab-2'" class="px-2 pb-2">
              <StatusExpansionPanels
                :img_url="dataItem.image_url"
                :panels="dataListMyMission"
                :employee_id="dataItem.employee_mission_id"
                :openPanel="openPanel"
                :showPanel="showPanel"
                :dataMission="dataItem"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-col>
    </v-row>

    <v-footer fixed padless color="white">
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-row class="pt-4" justify="center">
              <v-col
                v-if="initial_check_allow_play && mission_status_join"
                cols="11"
                md="3"
                class="py-0 pb-4"
              >
                <v-btn
                  block
                  class="pa-5 rounded-lg white--text"
                  :color="site.color"
                  @click="confirmMission()"
                >
                  {{ $t("activityJoin") }}
                </v-btn>
              </v-col>

              <!-- require_qr -->
              <v-col
                v-if="
                  initial_check_allow_play &&
                  dataItem.type === 'quest-tracking' &&
                  dataItem.require_qr &&
                  ['waiting'].includes(dataItem.mission_status)
                "
                cols="11"
                md="3"
                class="py-0 pb-4"
              >
                <v-btn
                  block
                  class="pa-5 rounded-lg white--text"
                  :color="site.color"
                  @click="openQrDialog()"
                >
                  {{ $t("activityQr") }}
                </v-btn>
              </v-col>

              <!-- is_top_ranking -->
              <v-col
                v-if="
                  dataItem.type == 'survey' &&
                  dataItem.is_top_ranking &&
                  ['success', 'waiting', 'failed'].includes(
                    dataItem.mission_status
                  )
                "
                cols="11"
                md="3"
                class="py-0 pb-4"
              >
                <v-btn
                  block
                  class="pa-5 rounded-lg"
                  :color="site.color"
                  dark
                  @click="goToTopRanking"
                >
                  {{ $t("textTopRanking") }}
                </v-btn>
              </v-col>

              <!-- สำหรับกรณ๊ mcommerce survey approve reject แล้ว เล่นซ้ำไม่ได้ -->
              <v-col
                v-if="
                  false &&
                  dataItem.mission_status === 'failed' &&
                  dataItem.is_can_edit_rejected === true &&
                  dataItem.is_approve === true &&
                  dataItem.type === 'survey'
                "
                cols="11"
                md="3"
                class="py-0 pb-4"
              >
                <v-btn
                  block
                  class="pa-5 rounded-lg white--text"
                  :color="site.color"
                  @click="confirmSurvey()"
                >
                  {{ $t("newActivityUpload") }}
                </v-btn>
              </v-col>

              <!-- ========== ========== Button Back ========== ========== -->
              <v-col cols="11" md="3" class="py-0 pb-4">
                <v-btn
                  block
                  class="pa-5 rounded-lg"
                  :color="site.color"
                  outlined
                  @click="redirectTo()"
                >
                  {{ $t("back") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <DialogScan
      :dialogScan="dialogScan"
      :refMissionId="missionId"
      @closeDialogScan="dialogScan = false"
      @onScanSuccess="handleScanSuccess"
    />
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import moment from "moment";
import { mapState } from "vuex";
import { Model } from "survey-core";
import { Survey } from "survey-vue-ui";
import "survey-core/defaultV2.min.css";
import documentIcon from "@/assets/images/svg/document.svg";
import questTrackingData from "@/views/Customer/Mission/component/questTrackingData.vue";
import {
  addClassQlEditorToSDDisplay,
  formatHtmlDetailDefault,
} from "../../../config/general-function";
import StatusExpansionPanels from "@/views/Customer/Mission/component/listMyMission.vue";
import DialogScan from "@/components/activity/dialogScan.vue";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  components: {
    Survey,
    questTrackingData,
    StatusExpansionPanels,
    DialogScan,
    PointSymbol,
  },
  data: () => ({
    drawer: false,
    group: null,
    dataItem: [],
    qrcode_key: "",
    employee_mission_id: "",
    kahoot_link: "https://kahoot.it/",
    schema_survey: null,
    survey: null,
    answer: null,
    upload: null,
    showMissionDetail: false,
    check_in: null,
    selected: null,
    countGroupItem: 0,
    note: "",
    isAnonymous: false,
    employee_send_to: "",
    questTrackingData: [],
    conditionSpecial: {},
    user: null,
    tab: "tab-1",
    openPanel: [0, 1, 2, 3],
    showPanel: true,
    dataListMyMission: [
      {
        key: "join",
        color: "blue",
        bgColor: "#E3F2FD",
        icon: "mdi-account-reactivate-outline",
        panelStyle: {
          border: "1px solid #2196F3",
        },
        count: 0,
        items: [],
        total_reward: [],
      },

      {
        key: "waiting",
        color: "orange",
        bgColor: "#FFF3E0",
        icon: "mdi-clock-outline",
        panelStyle: {
          border: "1px solid orange",
        },
        count: 0,
        items: [],
        total_reward: [],
      },

      {
        key: "success",
        color: "green",
        bgColor: "#E8F5E9",
        icon: "mdi-check-circle-outline",
        panelStyle: {
          border: "1px solid green",
        },
        count: 0,
        items: [],
        total_reward: [],
      },

      {
        key: "failed",
        color: "red",
        bgColor: "#FFEBEE",
        icon: "mdi-close-circle-outline",
        panelStyle: {
          border: "1px solid red",
        },
        count: 0,
        items: [],
        total_reward: [],
      },
    ],
    dialogScan: false,
    missionId: null,
    previousRouteName: null,
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm คือตัวแทนของ this
      const currentRouteName = to.name;
      if (from?.fullPath && from?.fullPath !== "/") {
        sessionStorage.setItem(
          currentRouteName + "_prev_route_name",
          from.name
        );
        vm.previousRouteName = from.name;
      } else {
        vm.previousRouteName = sessionStorage.getItem(
          currentRouteName + "_prev_route_name"
        );
      }
    });
  },
  async created() {
    await this.getMissionDetail();

    if (
      this.dataItem.mission_status === "success" ||
      this.dataItem.mission_status === "waiting" ||
      this.dataItem.mission_status === "failed"
    ) {
      if (
        this.dataItem.type !== "upload" &&
        this.dataItem.type !== "check-in"
      ) {
        await this.getMyMissionAnswer();
      } else if (this.dataItem.type === "check-in") {
        await this.getMyCheckInTimestamp();
      }
    }
    this.survey = new Model(JSON.stringify(this.schema_survey));
    // this.survey.data = JSON.parse(this.answer);
    this.survey.data = this.answer;
    this.survey.mode = "display";
    this.survey.showProgressBar = "off";
    this.survey.showTimerPanel = "none";

    this.onSetEventSurvey();
    // ========== ========== ========== ==========
    this.onAfterRenderPage();
    // ========== ========== ========== ==========
    this.getListMymission();
  },
  methods: {
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    onAfterRenderPage() {
      this.survey.onAfterRenderPage.add(function (sender, options) {
        console.log(options);
        addClassQlEditorToSDDisplay();
      });
      addClassQlEditorToSDDisplay();
    },
    goToTopRanking() {
      this.$router.push({
        name: "top-ranking",
        params: {
          id: this.dataItem.id,
        },
      });
    },
    redirectTo() {
      if (this.previousRouteName) {
        const fromName = this.$router.previousRouteFrom?.name;
        if (
          [
            "mission-survey",
            "mission-upload",
            "mission-lucky-draw",
            "mission-checkin",
          ].includes(fromName)
        ) {
          this.$router.push({
            name: "mission",
          });
          return;
        }
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: "mission",
        });
      }
    },
    onSetEventSurvey() {
      this.survey.onAfterRenderQuestion.add((survey, options) => {
        if (options.question.getType() === "file") {
          const questionName = options.question.name;
          const filePreviewContainer =
            options.htmlElement.querySelector(".sd-file__list");
          if (!filePreviewContainer) return;
          const previewItem = filePreviewContainer.getElementsByClassName(
            "sd-file__preview-item"
          );
          if (Array.isArray(Array.from(previewItem))) {
            let index = -1;
            for (let item of previewItem) {
              index++;
              const divWrapper = item.querySelector(".sd-file__image-wrapper");
              if (divWrapper) {
                const imageElement = divWrapper.querySelector("img");
                if (imageElement) {
                  const src = imageElement.src;
                  if (!this.isImage(src)) {
                    imageElement.style.display = "none";
                    if (this.isVideo(src)) {
                      const videoElement = document.createElement("video");
                      // videoElement.controls = true;
                      videoElement.style.maxWidth = "100%";
                      videoElement.style.maxHeight = "100%";
                      videoElement.src = src;
                      imageElement.parentNode.appendChild(videoElement);
                    } else {
                      const answer = this.answer[questionName];
                      if (Array.isArray(answer) && answer.length > 0) {
                        const htmlElement = document.createElement("div");
                        htmlElement.style.maxWidth = "100%";
                        htmlElement.style.maxHeight = "100%";
                        htmlElement.style.display = "flex";
                        htmlElement.style.flexDirection = "column";
                        htmlElement.style.alignItems = "center";
                        htmlElement.title = answer[index].content_name;
                        const imgDivElement = document.createElement("img");
                        imgDivElement.style.width = "40px";
                        imgDivElement.style.height = "40px";
                        imgDivElement.style.objectFit = "contain";
                        imgDivElement.style.marginBottom = "4px";
                        imgDivElement.src = documentIcon;
                        htmlElement.appendChild(imgDivElement);
                        const spanElement = document.createElement("span");
                        spanElement.style.width = "80%";
                        spanElement.style.overflow = "hidden";
                        spanElement.style.textOverflow = "ellipsis";
                        spanElement.style.whiteSpace = "nowrap";
                        spanElement.innerHTML = answer[index].content_name;
                        htmlElement.appendChild(spanElement);
                        imageElement.parentNode.appendChild(htmlElement);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
    },
    async getListMymission() {
      try {
        const listMyMission = await Axios.get("mission/getListMyMission", {
          params: { employee_mission_id: this.$route.params.id },
        });
        let listData = listMyMission.data.data;
        listData.forEach((element) => {
          this.dataListMyMission[element.status].count = element.count;
          this.dataListMyMission[element.status].items = element.items;
          this.dataListMyMission[element.status].total = element.total;
          this.dataListMyMission[element.status].total_reward =
            element.total_reward;
        });

        //open panel
        if (listData.length > 0) {
          this.showPanel = true;

          let from = this.$route.query.from;
          if (from == undefined || from == "all") {
            this.openPanel = [0, 1, 2, 3];
          } else {
            this.openPanel = [Number.parseInt(from)];
          }
        } else {
          this.showPanel = false;
        }
      } catch (err) {
        console.log("err :>> ", err);
        this.$router.push({
          name: "mission",
        });
      }
    },
    async getMissionDetail() {
      try {
        const myMission = await Axios.get("mission/getMyMission", {
          params: {
            employee_mission_id: this.$route.params.id,
            view_in_period_remind_date: true,
            view_limit_reached: true,
          },
        });
        this.dataItem = myMission.data.data;
        this.missionId = this.dataItem.id;
        if (
          this.dataItem.type === "survey" ||
          this.dataItem.type === "exam" ||
          this.dataItem.type === "upload"
        ) {
          this.schema_survey = myMission.data.data.schema_survey;
          if (typeof this.schema_survey == "string") {
            this.schema_survey = JSON.parse(this.schema_survey);
          }
          this.schema_survey.showPrevButton = true;
          (this.schema_survey.completeText = {
            default: this.$t("submitResult"),
          }),
            (this.schema_survey.pageNextText = {
              default: this.$t("next"),
            }),
            (this.schema_survey.pagePrevText = {
              default: this.$t("back"),
            });
        }
        if (this.dataItem.type === "quest-tracking") {
          this.questTrackingData = this.dataItem.quest_tracking_data;
          this.conditionSpecial = this.dataItem.condition_special;
        }
        this.user = this.dataItem.user;
      } catch (err) {
        console.log("err :>> ", err);
        this.$router.push({
          name: "mission",
        });
      }
    },
    async getMyMissionAnswer() {
      try {
        const missionAnswer = await Axios.get("mission/getMyMissionAnswer", {
          params: {
            mission_id: this.dataItem.id,
            employee_missions_id: this.dataItem.employee_mission_id,
          },
        });
        // this.answer = missionAnswer.data.survey[0].answer;
        if (missionAnswer.data.survey == null) {
          return (this.answer = null);
        }

        const answerResponse = JSON.parse(missionAnswer.data.survey.answer);

        if (missionAnswer.data.survey.answer != null) {
          const answer = {};
          for (const i in answerResponse) {
            if (Array.isArray(answerResponse[i])) {
              answer[i] = [];
              for (const [index, j] of answerResponse[i].entries()) {
                if (j.content != undefined) {
                  answer[i].push({
                    name: `${i}-${index}`,
                    type: "image/*",
                    content: j.content,
                    content_name: j.name,
                  });
                } else {
                  answer[i].push(j);
                }
              }
            } else {
              answer[i] = answerResponse[i];
            }
          }
          this.answer = answer;
          if (this.dataItem.type == "multi-upload") {
            let pages = this.dataItem.schema_survey?.pages;
            if (Array.isArray(pages)) {
              let listElement = [];
              pages.forEach((element) => {
                listElement = [...listElement, ...element.elements];
              });
              for (let key in this.answer) {
                const model = listElement.find((x) => x.name == key);
                if (model?.type == "file") {
                  if (
                    Array.isArray(this.answer[key]) &&
                    this.answer[key].length > 0
                  ) {
                    this.dataItem.image_upload = this.answer[key][0].content;
                  }
                } else if (model?.type == "text") {
                  let unit = "";
                  const condition_reward_type =
                    this.dataItem?.condition_reward?.type;
                  if (condition_reward_type == "point-per-distance") {
                    unit = this.$t("unit.km");
                  } else if (condition_reward_type == "point-per-cc") {
                    unit = this.$t("unit.cc");
                  } else if (condition_reward_type == "point-per-unit") {
                    unit = this.$t("unit.unit");
                  }
                  this.dataItem.description = `${this.answer[key]} ${unit}`;
                }
              }
            }
          } else if (this.dataItem.type == "survey-summary") {
            const pages = this.dataItem.schema_survey?.pages;
            const condition_result = this.dataItem?.condition_result;
            if (Array.isArray(pages)) {
              let _choices = [];
              let _questions = [];
              let _answers = [];
              for (let item of pages) {
                item.elements.map((_element) => {
                  _questions.push(_element);
                  if (this.answer[_element.name]) {
                    const ans = this.answer[_element.name];
                    const index = _element.choices.findIndex(
                      (x) => x == ans || x.value == ans
                    );
                    if (index >= 0) {
                      _choices.push(index + 1);
                      _answers.push({
                        question: _element.name,
                        answer: ans,
                      });
                    }
                  }
                });
              }
              if (condition_result?.type == "most-selected") {
                const mostFrequentValue = this.getMostFrequentValue(_choices);
                if (Array.isArray(condition_result.list)) {
                  const model = condition_result.list.find(
                    (x) => x.choice == mostFrequentValue
                  );
                  if (model) {
                    this.dataItem.image_upload = model.image_path;
                    this.dataItem.description = model.description;
                  }
                }
              } else if (condition_result?.type == "weighted-scoring") {
                const sumChoiceValue = this.getSumChoiceValue(
                  _questions,
                  _answers
                );
                if (Array.isArray(condition_result.list)) {
                  const model = condition_result.list.find((x) => {
                    let check = false;
                    let min = 0;
                    let max = 0;
                    if (!isNaN(Number(x.min))) {
                      min = x.min;
                    }
                    if (!isNaN(Number(x.max))) {
                      max = x.max;
                    }
                    if (min <= sumChoiceValue && sumChoiceValue <= max) {
                      check = true;
                    }
                    return check;
                  });
                  if (model) {
                    this.dataItem.image_upload = model.image_path;
                    this.dataItem.description = model.description;
                  }
                }
              }
            }
          }
        }
      } catch (err) {
        console.log("err :>> ", err);
        this.$router.push({
          name: "mission",
        });
      }
    },
    getMostFrequentValue(arr) {
      if (arr.length === 0) return null;

      const frequencyMap = {};

      // Create frequency map
      arr.forEach((item) => {
        if (frequencyMap[item]) {
          frequencyMap[item]++;
        } else {
          frequencyMap[item] = 1;
        }
      });

      // Find the element with the highest frequency
      let maxCount = 0;
      let mostFrequentElement = arr[0];

      for (const [key, value] of Object.entries(frequencyMap)) {
        if (value > maxCount) {
          maxCount = value;
          mostFrequentElement = key;
        }
      }

      return mostFrequentElement;
    },
    getSumChoiceValue(questions, answers) {
      let sumChoiceValue = 0;
      for (let item of questions) {
        let model = answers.find((x) => x.question == item.name);
        if (model) {
          let choice = item.choices.find(
            (x) => x.value == model.answer || x == model.answer
          );
          if (choice) {
            sumChoiceValue += choice.score == undefined ? 1 : choice.score;
          }
        }
      }
      return sumChoiceValue;
    },
    async getMyCheckInTimestamp() {
      try {
        const checkIn = await Axios.get("mission/getMyCheckInTimestamp", {
          params: { employee_mission_id: this.$route.params.id },
        });
        this.check_in = checkIn.data.employee_checkin[0];
      } catch (err) {
        console.log("err :>> ", err);
        this.$router.push({
          name: "mission",
        });
      }
    },
    formattedText(text) {
      if (text == null) {
        return "-";
      }
      return text.replace(/\n/g, "<br>");
    },

    openQrDialog() {
      this.dialogScan = true;
    },
    handleScanSuccess(param) {
      const mission_type = param.mission_type;
      if (mission_type == "quest-tracking") {
        window.location.reload();
      }
    },

    // ========== ========== Confirm Mission ========== ==========
    confirmMission() {
      if (["upload"].includes(this.dataItem.type)) {
        this.confirmUpload();
      } else if (["kahoot"].includes(this.dataItem.type)) {
        this.confirmKahoot();
      } else if (["check-in"].includes(this.dataItem.type)) {
        this.confirmCheckin();
      } else if (["lucky draw"].includes(this.dataItem.type)) {
        this.confirmLuckyDraw();
      } else if (
        ["survey", "exam", "multi-upload", "survey-summary"].includes(
          this.dataItem.type
        )
      ) {
        this.confirmSurvey();
      }
    },
    confirmSurvey() {
      this.$router.push({
        name: "mission-survey",
        params: { employee_mission_id: this.$route.params.id },
      });
    },
    confirmUpload() {
      this.$router.push({
        name: "mission-upload",
        params: { employee_mission_id: this.$route.params.id },
      });
    },
    confirmLuckyDraw() {
      this.$router.push({
        name: "mission-lucky-draw",
        params: { employee_mission_id: this.$route.params.id },
      });
    },
    confirmCheckin() {
      this.$router.push({
        name: "mission-checkin",
        params: { id: this.$route.params.id },
      });
    },
    confirmKahoot() {
      if (this.dataItem.link_kahoot != null) {
        return window.open(this.dataItem.link_kahoot, "_blank");
      } else {
        return window.open(this.kahoot_link, "_blank");
      }
    },
    // ========== ========== ========== ==========

    handleClickDetailMission() {
      this.showMissionDetail = !this.showMissionDetail;
      if (this.showMissionDetail && this.$refs.cardDetailMission) {
        this.$refs.cardDetailMission.$el.blur();
      }
    },
    getMostFrequentElement(arr) {
      if (arr.length === 0) return null;

      const frequencyMap = {};

      // Create frequency map
      arr.forEach((item) => {
        if (frequencyMap[item]) {
          frequencyMap[item]++;
        } else {
          frequencyMap[item] = 1;
        }
      });

      // Find the element with the highest frequency
      let maxCount = 0;
      let mostFrequentElement = arr[0];

      for (const [key, value] of Object.entries(frequencyMap)) {
        if (value > maxCount) {
          maxCount = value;
          mostFrequentElement = key;
        }
      }

      return mostFrequentElement;
    },
    isImage(link) {
      return /\.(gif|jpe?g|jfif|tiff?|png|webp|bmp|avif|svg)$/i.test(link);
    },
    isVideo(link) {
      return /\.(mp4|webm|ogg|avi|mov)$/i.test(link);
    },
    isPDF(link) {
      return /\.pdf$/i.test(link);
    },
    isSpreadsheet(link) {
      return /\.(xls|xlsx|csv)$/i.test(link);
    },
    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
    formatTitleSurvey(key, value) {
      let title = "";
      if (
        value.condition_reward?.type == "point-per-distance" ||
        value.condition_reward?.type == "point-per-cc" ||
        value.condition_reward?.type == "point-per-unit"
      ) {
        const pages = value.schema_survey?.pages;
        if (Array.isArray(pages) && pages.length > 0) {
          const elements = pages[0].elements;
          if (Array.isArray(elements) && elements.length > 1) {
            if (key == "upload") {
              title = elements[0].title || "";
            } else if (key == "amount") {
              title = elements[1].title || "";
            }
          }
        }
      }
      return title;
    },
    getRewardName(data) {
      let rewards = data.mission_rewards;
      if (rewards == undefined) {
        return "-";
      } else if (rewards.length == 0) return "-";
      else return rewards.map((reward) => reward.name).join(", ");
    },
    showPoint(pararm) {
      let pointDetail = {
        point: 0,
        point_type_name: "",
      };
      if (Array.isArray(pararm.point) && pararm.point.length > 0) {
        pointDetail = pararm.point[0];
      }
      if (pararm.use_reward == true) {
        return `${this.$t("rewardPrize")}`;
      } else if (pointDetail.point == 0 || pararm.type == "check-in") {
        return `${this.$t("conditionCoin")}`;
      } else if (Array.isArray(pararm.point) && pararm.point.length > 1) {
        // return `${this.$t("textNumberMore", { number: pararm.point.length })}`;
        return `+${pararm.point.length}`;
      } else {
        const formattedPoint = this.$options.filters.commaPoint(
          pointDetail.point
        );
        return `${formattedPoint} ${pointDetail.point_type_name}`;
      }
    },
    category(value) {
      if (!value) return this.$t("textNotSpecified");
      return value;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    ...mapState("login", ["mobile"]),
    descriptionTextarea() {
      return this.dataItem.description ? this.dataItem.description : "-";
    },
    noteFailTextarea() {
      return this.dataItem.note ? this.dataItem.note : "-";
    },
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
    initial_check_allow_play() {
      return (
        !this.dataItem.limit_reached &&
        this.dataItem.quest_tracking_allow_play &&
        this.dataItem.has_permission_play &&
        !this.dataItem.in_period_remind_date &&
        this.dataItem.in_period_show_time_selected
      );
    },
    mission_status_join() {
      let check = false;
      if (["join"].includes(this.dataItem.mission_status)) {
        check = true;
      }
      return check;
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style>
.sd-body {
  margin-bottom: 20% !important;
}
</style>

<style scoped>
::v-deep .v-expansion-panel-content__wrap {
  padding: 0px 12px 12px 12px !important;
}
.ellipsis {
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.spaceBottom {
  margin-bottom: 30%;
}

.sv-components-column .sd-action-bar #sv-nav-complete {
  display: none;
}

/* preview image  */
.sd-file__wrapper {
  display: none !important;
}

.sd-file__list {
  padding-top: 0;
  padding-bottom: 0;
  height: 100% !important;
  /* width: 100%; */
  max-height: none !important;
}

.sd-file__preview {
  height: 80% !important;
  min-height: 0 !important;
  /* width: 50% !important; */
}

.sd-file__image-wrapper {
  margin: auto !important;
}

.sd-file__image-wrapper img {
  height: 100% !important;
  width: 100% !important;
}

.sd-file__sign {
  display: none;
}

.sv-action-bar--default-size-mode {
  margin-top: 20px;
}

.sd-navigation__next-btn,
.sd-navigation__prev-btn {
  margin-bottom: 80px !important;
}

.v-text-field--outlined >>> fieldset {
  border-width: 0px;
}

/* ::v-deep .sd-timer {
  display: none !important;
} */

img {
  width: 100% !important;
}
</style>
